<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/The_Spirit_and_the_Skull2#Contents-A">Dedication</a></p>
<p class="Body-Center para-style-override-3"><span class="Italic char-style-override-2">For Karl, who introduced me to the tundra and The People.<br/>For Egon, Hal, and Jon, who shared the magic.<br/>And in memory of Claire for making it possible.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Spirit_and_the_Skull3.vue?3f778bc4